import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomizerSettingsService {
    
    // Dark Mode
    private isDarkTheme: boolean;

    // Sidebar Dark Mode
    private isSidebarDarkTheme: boolean;

    // Right Sidebar
    private isRightSidebarTheme: boolean;

    // Hide Sidebar
    private isHideSidebarTheme: boolean;

    // Header Dark Mode
    private isHeaderDarkTheme: boolean;

    // Card Border
    private isCardBorderTheme: boolean;

    // Card Border Radius
    private isCardBorderRadiusTheme: boolean;

    // RTL Mode
    private isRTLEnabledTheme: boolean;

    constructor() {
        // Dark Mode
        this.isDarkTheme = JSON.parse(sessionStorage.getItem('isDarkTheme')!);

        // Sidebar Dark Mode
        this.isSidebarDarkTheme = JSON.parse(sessionStorage.getItem('isSidebarDarkTheme')!);

        // Right Sidebar
        this.isRightSidebarTheme = JSON.parse(sessionStorage.getItem('isRightSidebarTheme')!);

        // Hide Sidebar
        this.isHideSidebarTheme = JSON.parse(sessionStorage.getItem('isHideSidebarTheme')!);

        // Header Dark
        this.isHeaderDarkTheme = JSON.parse(sessionStorage.getItem('isHeaderDarkTheme')!);

        // Card Border
        this.isCardBorderTheme = JSON.parse(sessionStorage.getItem('isCardBorderTheme')!);

        // Card Border Radius
        this.isCardBorderRadiusTheme = JSON.parse(sessionStorage.getItem('isCardBorderRadiusTheme')!);

        // RTL Mode
        this.isRTLEnabledTheme = JSON.parse(sessionStorage.getItem('isRTLEnabledTheme')!);
    }

    // Dark Mode
    toggleTheme() {
        this.isDarkTheme = !this.isDarkTheme;
        sessionStorage.setItem('isDarkTheme', JSON.stringify(this.isDarkTheme));
    }
    isDark() {
        return this.isDarkTheme;
    }

    // Sidebar Dark
    toggleSidebarTheme() {
        this.isSidebarDarkTheme = !this.isSidebarDarkTheme;
        sessionStorage.setItem('isSidebarDarkTheme', JSON.stringify(this.isSidebarDarkTheme));
    }
    isSidebarDark() {
        return this.isSidebarDarkTheme;
    }

    // Right Sidebar
    toggleRightSidebarTheme() {
        this.isRightSidebarTheme = !this.isRightSidebarTheme;
        sessionStorage.setItem('isRightSidebarTheme', JSON.stringify(this.isRightSidebarTheme));
    }
    isRightSidebar() {
        return this.isRightSidebarTheme;
    }

    // Hide Sidebar
    toggleHideSidebarTheme() {
        this.isHideSidebarTheme = !this.isHideSidebarTheme;
        sessionStorage.setItem('isHideSidebarTheme', JSON.stringify(this.isHideSidebarTheme));
    }
    isHideSidebar() {
        return this.isHideSidebarTheme;
    }

    // Header Dark Mode
    toggleHeaderTheme() {
        this.isHeaderDarkTheme = !this.isHeaderDarkTheme;
        sessionStorage.setItem('isHeaderDarkTheme', JSON.stringify(this.isHeaderDarkTheme));
    }
    isHeaderDark() {
        return this.isHeaderDarkTheme;
    }

    // Card Border
    toggleCardBorderTheme() {
        this.isCardBorderTheme = !this.isCardBorderTheme;
        sessionStorage.setItem('isCardBorderTheme', JSON.stringify(this.isCardBorderTheme));
    }
    isCardBorder() {
        return this.isCardBorderTheme;
    }

    // Card Border Radius
    toggleCardBorderRadiusTheme() {
        this.isCardBorderRadiusTheme = !this.isCardBorderRadiusTheme;
        sessionStorage.setItem('isCardBorderRadiusTheme', JSON.stringify(this.isCardBorderRadiusTheme));
    }
    isCardBorderRadius() {
        return this.isCardBorderRadiusTheme;
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.isRTLEnabledTheme = !this.isRTLEnabledTheme;
        sessionStorage.setItem('isRTLEnabledTheme', JSON.stringify(this.isRTLEnabledTheme));
    }
    isRTLEnabled() {
        return this.isRTLEnabledTheme;
    }

    // isToggled
    private isToggled = new BehaviorSubject<boolean>(false);
    get isToggled$() {
        return this.isToggled.asObservable();
    }
    toggle() {
        this.isToggled.next(!this.isToggled.value);
    }
    
}